// Generated by purs version 0.15.0
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Eq_Generic from "../Data.Eq.Generic/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Money_Rounded from "../Data.Money.Rounded/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Data_Numeric from "../Data.Numeric/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Restaumatic_PromotionsEngine_Cart_CartParams from "../Restaumatic.PromotionsEngine.Cart.CartParams/index.js";
import * as Restaumatic_PromotionsEngine_Cart_ProductItem from "../Restaumatic.PromotionsEngine.Cart.ProductItem/index.js";
import * as Restaumatic_PromotionsEngine_Cart_PromotionalItem from "../Restaumatic.PromotionsEngine.Cart.PromotionalItem/index.js";
import * as Restaumatic_PromotionsEngine_Promotions_Types_Promotion from "../Restaumatic.PromotionsEngine.Promotions.Types.Promotion/index.js";
var OutputCartData = function (x) {
    return x;
};
var InputCartData = function (x) {
    return x;
};
var newtypeOutputCartData = {
    Coercible0: function () {
        return undefined;
    }
};
var promotionalItems = /* #__PURE__ */ (function () {
    var $32 = Data_Newtype.unwrap();
    return function ($33) {
        return (function (v) {
            return v.promotionalItems;
        })($32($33));
    };
})();
var setAllFreeProducts = function (allFreeProductsInit) {
    return function (outputCartData) {
        return Data_Newtype.wrap()((function () {
            var v = Data_Newtype.unwrap()(outputCartData);
            var $19 = {};
            for (var $20 in v) {
                if ({}.hasOwnProperty.call(v, $20)) {
                    $19[$20] = v[$20];
                };
            };
            $19.allFreeProducts = allFreeProductsInit;
            return $19;
        })());
    };
};
var subtotal = /* #__PURE__ */ (function () {
    var $34 = Data_Newtype.unwrap();
    return function ($35) {
        return (function (v) {
            return v.subtotal;
        })($34($35));
    };
})();
var total = /* #__PURE__ */ (function () {
    var $36 = Data_Newtype.unwrap();
    return function ($37) {
        return (function (v) {
            return v.total;
        })($36($37));
    };
})();
var subFromTotal = function (money) {
    return function (outputCartData) {
        var newTotal = Data_Ord.max(Data_Money_Rounded.ordMoney)(Data_Numeric.zero(Data_Money_Rounded.additiveMoney))(Data_Numeric.sub(Data_Money_Rounded.additiveMoney)(total(outputCartData))(money));
        return Data_Newtype.wrap()((function () {
            var v = Data_Newtype.unwrap()(outputCartData);
            var $22 = {};
            for (var $23 in v) {
                if ({}.hasOwnProperty.call(v, $23)) {
                    $22[$23] = v[$23];
                };
            };
            $22.total = newTotal;
            return $22;
        })());
    };
};
var newtypeInputCartData = {
    Coercible0: function () {
        return undefined;
    }
};
var productItems = /* #__PURE__ */ (function () {
    var $38 = Data_Newtype.unwrap();
    return function ($39) {
        return (function (v) {
            return v.productItems;
        })($38($39));
    };
})();
var mkOutputCartData = function (productItemsInit) {
    return function (promotionalItemsInit) {
        return function (subtotalInit) {
            return function (totalInit) {
                return function (allFreeProductsInit) {
                    return {
                        productItems: productItemsInit,
                        promotionalItems: promotionalItemsInit,
                        subtotal: subtotalInit,
                        total: totalInit,
                        allFreeProducts: allFreeProductsInit
                    };
                };
            };
        };
    };
};
var mkInputCartData = function (productsArr) {
    return {
        productItems: Data_Array.concat(productsArr),
        orderType: Restaumatic_PromotionsEngine_Cart_CartParams.Delivery.value,
        deliveryZone: Restaumatic_PromotionsEngine_Cart_CartParams.defaultDeliveryZone,
        requestedTime: Restaumatic_PromotionsEngine_Cart_CartParams.Asap.value,
        assignmentMode: Restaumatic_PromotionsEngine_Cart_CartParams.AutoAssign.value
    };
};
var genericOutputCartData = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showOutputCartData = function (dictShow) {
    return {
        show: Data_Show_Generic.genericShow(genericOutputCartData)(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(Data_Show.showRecord()()(Data_Show.showRecordFieldsCons({
            reflectSymbol: function () {
                return "allFreeProducts";
            }
        })(Data_Show.showRecordFieldsCons({
            reflectSymbol: function () {
                return "productItems";
            }
        })(Data_Show.showRecordFieldsCons({
            reflectSymbol: function () {
                return "promotionalItems";
            }
        })(Data_Show.showRecordFieldsCons({
            reflectSymbol: function () {
                return "subtotal";
            }
        })(Data_Show.showRecordFieldsCons({
            reflectSymbol: function () {
                return "total";
            }
        })(Data_Show.showRecordFieldsNil)(Data_Money_Rounded.showMoney))(Data_Money_Rounded.showMoney))(Data_Show.showArray(Restaumatic_PromotionsEngine_Cart_PromotionalItem.showPromotionalItem(dictShow))))(Data_Show.showArray(Restaumatic_PromotionsEngine_Cart_ProductItem.showProductItem(dictShow))))(Data_Show.showArray(Data_Show.showArray(Restaumatic_PromotionsEngine_Promotions_Types_Promotion.showFreeProduct))))))({
            reflectSymbol: function () {
                return "OutputCartData";
            }
        }))
    };
};
var genericInputCartData = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showInputCartData = function (dictShow) {
    return {
        show: Data_Show_Generic.genericShow(genericInputCartData)(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(Data_Show.showRecord()()(Data_Show.showRecordFieldsCons({
            reflectSymbol: function () {
                return "assignmentMode";
            }
        })(Data_Show.showRecordFieldsCons({
            reflectSymbol: function () {
                return "deliveryZone";
            }
        })(Data_Show.showRecordFieldsCons({
            reflectSymbol: function () {
                return "orderType";
            }
        })(Data_Show.showRecordFieldsCons({
            reflectSymbol: function () {
                return "productItems";
            }
        })(Data_Show.showRecordFieldsCons({
            reflectSymbol: function () {
                return "requestedTime";
            }
        })(Data_Show.showRecordFieldsNil)(Restaumatic_PromotionsEngine_Cart_CartParams.showRequestedTime))(Data_Show.showArray(Restaumatic_PromotionsEngine_Cart_ProductItem.showProductItem(dictShow))))(Restaumatic_PromotionsEngine_Cart_CartParams.showOrderType))(Restaumatic_PromotionsEngine_Cart_CartParams.showDeliveryZone))(Restaumatic_PromotionsEngine_Cart_CartParams.showAssignmentMode))))({
            reflectSymbol: function () {
                return "InputCartData";
            }
        }))
    };
};
var findProduct = function (dictEq) {
    return function (inputCartData) {
        return function (itemKey) {
            var equalKey = function (productItem) {
                return Data_Eq.eq(Restaumatic_PromotionsEngine_Cart_ProductItem.eqProductItemKey(dictEq))(itemKey)(Restaumatic_PromotionsEngine_Cart_ProductItem.productItemKey(productItem));
            };
            return Data_Foldable.find(Data_Foldable.foldableArray)(equalKey)(productItems(inputCartData));
        };
    };
};
var eqOutputCartData = function (dictEq) {
    return {
        eq: Data_Eq_Generic.genericEq(genericOutputCartData)(Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqArgument(Data_Eq.eqRec()(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowNil)()({
            reflectSymbol: function () {
                return "total";
            }
        })(Data_Money_Rounded.eqMoney))()({
            reflectSymbol: function () {
                return "subtotal";
            }
        })(Data_Money_Rounded.eqMoney))()({
            reflectSymbol: function () {
                return "promotionalItems";
            }
        })(Data_Eq.eqArray(Restaumatic_PromotionsEngine_Cart_PromotionalItem.eqPromotionalItem(dictEq))))()({
            reflectSymbol: function () {
                return "productItems";
            }
        })(Data_Eq.eqArray(Restaumatic_PromotionsEngine_Cart_ProductItem.eqProductItem(dictEq))))()({
            reflectSymbol: function () {
                return "allFreeProducts";
            }
        })(Data_Eq.eqArray(Data_Eq.eqArray(Restaumatic_PromotionsEngine_Promotions_Types_Promotion.eqFreeProduct)))))))
    };
};
var eqInputCartData = function (dictEq) {
    return {
        eq: Data_Eq_Generic.genericEq(genericInputCartData)(Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqArgument(Data_Eq.eqRec()(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowNil)()({
            reflectSymbol: function () {
                return "requestedTime";
            }
        })(Restaumatic_PromotionsEngine_Cart_CartParams.eqRequestedTime))()({
            reflectSymbol: function () {
                return "productItems";
            }
        })(Data_Eq.eqArray(Restaumatic_PromotionsEngine_Cart_ProductItem.eqProductItem(dictEq))))()({
            reflectSymbol: function () {
                return "orderType";
            }
        })(Restaumatic_PromotionsEngine_Cart_CartParams.eqOrderType))()({
            reflectSymbol: function () {
                return "deliveryZone";
            }
        })(Restaumatic_PromotionsEngine_Cart_CartParams.eqDeliveryZone))()({
            reflectSymbol: function () {
                return "assignmentMode";
            }
        })(Restaumatic_PromotionsEngine_Cart_CartParams.eqAssignmentMode)))))
    };
};
var calcSubtotal = function (items) {
    return Data_Numeric.sum(Data_Foldable.foldableArray)(Data_Money_Rounded.additiveMoney)(Data_Functor.map(Data_Functor.functorArray)((function () {
        var $40 = Data_Newtype.unwrap();
        return function ($41) {
            return (function (v) {
                return v.productPrice;
            })($40($41));
        };
    })())(items));
};
var calcSubtotalCart = function (outputCartData) {
    return calcSubtotal((Data_Newtype.unwrap()(outputCartData)).productItems);
};
var calcSubtotalInputCartData = function (inputCartData) {
    return calcSubtotal((Data_Newtype.unwrap()(inputCartData)).productItems);
};
var mkDefaultOutputCartData = function (inputCartData) {
    return function (promotionalItemsInit) {
        var items = productItems(inputCartData);
        var subtotalInit = calcSubtotal(items);
        return mkOutputCartData(items)(promotionalItemsInit)(subtotalInit)(subtotalInit)([  ]);
    };
};
var assignmentMode = /* #__PURE__ */ (function () {
    var $42 = Data_Newtype.unwrap();
    return function ($43) {
        return (function (v) {
            return v.assignmentMode;
        })($42($43));
    };
})();
var allFreeProducts = /* #__PURE__ */ (function () {
    var $44 = Data_Newtype.unwrap();
    return function ($45) {
        return (function (v) {
            return v.allFreeProducts;
        })($44($45));
    };
})();
var addToTotal = function (money) {
    return function (outputCartData) {
        var newTotal = Data_Ord.max(Data_Money_Rounded.ordMoney)(Data_Numeric.zero(Data_Money_Rounded.additiveMoney))(Data_Numeric.add(Data_Money_Rounded.additiveMoney)(total(outputCartData))(money));
        return Data_Newtype.wrap()((function () {
            var v = Data_Newtype.unwrap()(outputCartData);
            var $29 = {};
            for (var $30 in v) {
                if ({}.hasOwnProperty.call(v, $30)) {
                    $29[$30] = v[$30];
                };
            };
            $29.total = newTotal;
            return $29;
        })());
    };
};
var addFreeProducts = function (freeProducts) {
    return function (outputCartData) {
        return setAllFreeProducts(Data_Array.cons(freeProducts)(allFreeProducts(outputCartData)))(outputCartData);
    };
};
export {
    InputCartData,
    productItems,
    assignmentMode,
    findProduct,
    OutputCartData,
    mkInputCartData,
    mkOutputCartData,
    mkDefaultOutputCartData,
    promotionalItems,
    allFreeProducts,
    total,
    subtotal,
    setAllFreeProducts,
    addFreeProducts,
    addToTotal,
    subFromTotal,
    calcSubtotalInputCartData,
    calcSubtotalCart,
    calcSubtotal,
    newtypeInputCartData,
    genericInputCartData,
    showInputCartData,
    eqInputCartData,
    newtypeOutputCartData,
    genericOutputCartData,
    showOutputCartData,
    eqOutputCartData
};
//# sourceMappingURL=index.js.map
